import classes from './style/contact.module.css'
const Contact = () => {
    return (
        <div className={classes.contactContainer}>
            <h1 className='title'>
                Contact me
            </h1>
            <p className='subTitle color2'>
                <span className='subTitleBefore'>
                /*
                </span> Have an exciting project you need help with?
                <span className='subTitleAfter'>
                    */
                </span>
            </p>
            <form action="https://formsubmit.co/yosefadel002@gmail.com" method="POST">
                <div className={classes.inputCon}>
                    <input type="text" name="name" placeholder="Full Name" required />
                </div>
                <div className={classes.inputCon}>
                    <input type="email" name="email" placeholder="Email Address" required />
                </div>
                <div className={classes.inputCon}>
                    <textarea name="name" rows="8" placeholder="Message"></textarea>
                </div>

                <button type='submit' className={classes.btn}> <span>S</span>end</button>

            </form>
        </div>
    )
}

export default Contact
